import { ColDef } from "ag-grid-community";

/**
 * Empty default column type
 */
export const DefaultColumn: ColDef = {
	floatingFilter: true,
	filterParams: {
		maxNumConditions: 10,
	},
};
